import {
  REPORT_FRONTLINE_COACHES,
  REPORT_NEW_FRONTLINE_COACHES,
} from '/enum/records.enum';

export default {
  reportName: REPORT_FRONTLINE_COACHES,
  newReportName: REPORT_NEW_FRONTLINE_COACHES,
};
